/** The hour width before the grid has been measured (and in tests, which lay nothing out). */
const PIXELS_PER_HOUR = 300;

interface EpgTimelineProps {
  windowStart: Date;
  hours: number;
  /** Width of one hour, from EpgGrid: the grid's width over the hours on screen. */
  pxPerHour?: number;
}

/** The horizontal time ruler at the top of the EPG grid. */
export function EpgTimeline({ windowStart, hours, pxPerHour = PIXELS_PER_HOUR }: EpgTimelineProps) {
  const ticks: { label: string; leftPx: number }[] = [];
  const startHour = windowStart.getHours();
  for (let h = 0; h <= hours; h += 1) {
    const hour = (startHour + h) % 24;
    const ampm = hour >= 12 ? "PM" : "AM";
    const h12 = hour % 12 || 12;
    ticks.push({
      label: `${h12} ${ampm}`,
      leftPx: h * pxPerHour,
    });
  }

  return (
    <div className="epg-timeline" style={{ width: hours * pxPerHour }}>
      {ticks.map((tick) => (
        <div key={tick.leftPx} className="epg-timeline-tick" style={{ left: tick.leftPx }}>
          {tick.label}
        </div>
      ))}
    </div>
  );
}

export { PIXELS_PER_HOUR };
